// @ts-nocheck
import { Card, FormControlLabel, Grid, Tooltip, TextField, Box } from "@mui/material";
import { ComputerKeyboardIcon, OilGasMeterIcon } from "component/commonComponents/Icon";
import React from "react";
import { useDrag } from 'react-dnd';
import Typography from "../../../commonComponents/Typography";
import { UptimeCheckbox } from "../slider/checks";
import SelectBox from "component/commonComponents/selectBox";

export interface ISoureBoxProps {
  item?: any,
  onChange?: any,
  isChecked?: any,
  canDrag?: any,
  locale?: any,
  renderEyeBrow?: any,
  handleChangeKeyBoard?: Function,
  isPickup?: boolean
};

export const SourceBox: React.FC<ISoureBoxProps> = (props): JSX.Element => {
  const { item, onChange, isChecked, canDrag, locale, renderEyeBrow, handleChangeKeyBoard, isPickup } = props;

  const [{ opacity, cursor }, drag] = useDrag(
    () => ({
      type: 'box',
      item: item,
      canDrag: canDrag(item.uid),
      end: (item, monitor) => {
        const dropResult = monitor.getDropResult()
        if (item && dropResult) {
          onChange(item);
        }
      },
      collect: (monitor) => ({
        opacity: monitor.isDragging() ? 0.4 : 1,
        cursor: canDrag(item.uid) ? 'move' : 'default',
      }),
    }),
    [item, onChange, isChecked, canDrag],
  );

  return (
    <Card id='crd-sourcebox-container' ref={drag} style={{ opacity, cursor }} className={`slider-card-container ${isChecked(item.uid) ? 'selected' : ''}`}>
      <Grid
        container
        direction="row"
        alignItems="center"
        justifyContent="space-between"
      >
        <Grid item xs={6}>
          {renderEyeBrow()}
        </Grid>

        <Grid item xs={6} className='align-right-content'>
          <FormControlLabel
            control={
              <UptimeCheckbox 
                name={item.uid} 
                onChange={() => onChange(item)} 
                checked={isChecked(item.uid)} 
              />
            }
            className="compare-check"
            label={locale?.selectDeviceComponent?.compare}
            id="checkbox-sourcebox-selectdevice" />
        </Grid>
      </Grid>

      <Grid container direction="column" className="grid-column-source-box">
        <Box minHeight="72px">
          <Typography className="manufacturer" id="lbl-sourcebox-manufacturer">
            {item.manufacturer}
          </Typography>

          <Tooltip title={item?.name || item?.user_device_profile} arrow placement="bottom">
            <Typography className="title" id="lbl-sourcebox-name" display="block !important" maxWidth="100% !important">
              {item?.name || item?.user_device_profile}
            </Typography>
          </Tooltip>
        </Box>
        

        <Grid
          container
          direction="row"
          alignItems="center"
          justifyContent="center"
        >
          <img src={item.model_picture || item?.picture} alt={item.model} title={item.model} className="device-image" id="img-sourcebox-device"/>
        </Grid>
        {!!item.uid ? (<>
        <div className="spec-details">
          <Tooltip title={locale?.selectDeviceComponent?.tooltip.weight} arrow placement="left">
            <OilGasMeterIcon role="img" aria-label={locale?.selectDeviceComponent?.tooltip.weight} className="spec-icon"/>
          </Tooltip>
          <div className="spec-value" id="lbl-sourcebox-weight">{item.weight}</div>
        </div>

        <div className="spec-details">
          <Tooltip title={locale?.selectDeviceComponent?.tooltip.keyboardLayout} arrow placement="left">
            <ComputerKeyboardIcon role="img" aria-label={locale?.selectDeviceComponent?.tooltip.keyboardLayout} className="spec-icon"/>
          </Tooltip>

          {isPickup ?
            <div className="spec-value spec-value-keyboard">
              {item.keyboards.length > 1 ?
                <SelectBox
                  name='keyboard'
                  label=""
                  boldLabel
                  value={item.keyboards.length > 0 ? item.keyboards.find((k: any) => k.code === item.keyboardSelected) : {name: '', code: ''}}
                  handleChange={(e: any, val: any) => handleChangeKeyBoard(item.uid, val?.code)}
                  fullWidth
                  options={item.keyboards}
                  variant="outlined"
                  required
                  valueKey='code'
                  disableClearable
                  id="selectBox-keyboards"
                />
                : item.keyboards.length === 1 ?
                  <>
                    <p className="txt-keyboard" id="lbl-sourcebox-keyboards-name">{item.keyboards[0]?.name}</p>
                    <TextField type="hidden" defaultValue={item.keyboards[0]?.code} />
                  </>
                :
                <></>
              }
            </div>
            :
            <div className="spec-value" id="lbl-sourcebox-language">{item.language}</div>
          }
        </div>
        </>) : <></> }
      </Grid>
    </Card>
  )
};
